import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-slate-800">
      <Seo
        title="Termos e Condições | Web & Studio"
        description="Termos e Condições da Web & Studio aplicáveis à utilização do website e prestação de serviços."
        path="/terms"
      />

      <main className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="mb-10">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-800 font-medium">
            Voltar ao início
          </Link>
        </div>

        <header className="space-y-4 mb-12">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900">
            Termos e Condições
          </h1>
          <p className="text-slate-600">
            Última atualização: 16 de fevereiro de 2026.
          </p>
        </header>

        <section className="space-y-8 leading-relaxed">
          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">1. Objeto</h2>
            <p>
              Estes termos regulam o uso do website da Web & Studio e o contacto para pedidos de serviço.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">2. Utilização do site</h2>
            <p>
              O utilizador compromete-se a usar o website de forma lícita, sem comprometer segurança, disponibilidade ou integridade dos conteúdos.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">3. Propriedade intelectual</h2>
            <p>
              Conteúdos, design e elementos gráficos do site pertencem à Web & Studio, salvo indicação em contrário.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">4. Limitação de responsabilidade</h2>
            <p>
              A Web & Studio envida esforços para manter informação atualizada, mas não garante ausência total de erros ou interrupções técnicas.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">5. Contacto</h2>
            <p>
              Para questões contratuais, contacte:{" "}
              <a className="text-teal-700 hover:text-teal-800" href="mailto:contacto@webestudio.pt">
                contacto@webestudio.pt
              </a>
              .
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
